import type { ChangeEvent } from "react";
import { useAppDispatch } from "../../redux";
import { REGISTRATION_NUMBER_LENGTHS } from "../../constants";
import type { IRegistrationNumberInputProps } from "../../types";
import { setRegistrationNumber } from "../RegistrationPage/RegistrationPageSlice";
import { Help } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField, Tooltip, Typography } from "@mui/material";

export default function RegistrationNumberInput(props: IRegistrationNumberInputProps) {
  const {
    errors,
    label,
    tooltip,
    isTooltip,
    helperText,
    registrationNumber,
    setErrors,
    handleCloseTooltip,
    handleOpenTooltip,
  } = props;

  const dispatch = useAppDispatch();

  const handleRegistrationNumberChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget;

    if (!value || isNaN(Number(value))) return dispatch(setRegistrationNumber(null));

    if (!REGISTRATION_NUMBER_LENGTHS.includes(value.length)) setErrors({ ...errors, registrationNumber: true });
    else setErrors({ ...errors, registrationNumber: false });

    dispatch(setRegistrationNumber(Number(value)));
  };

  return (
    <TextField
      required
      fullWidth
      autoFocus
      type="tel"
      name="registrationNumber"
      autoComplete={"off"}
      value={registrationNumber ? registrationNumber : ""}
      onChange={handleRegistrationNumberChange}
      error={!registrationNumber ? false : errors.registrationNumber}
      helperText={helperText}
      label={`${label} ${registrationNumber ? String(registrationNumber).length : 0} / 6 - 7`}
      inputProps={{ maxLength: 7 }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <Tooltip
              title={<Typography>{tooltip}</Typography>}
              arrow
              onClose={handleCloseTooltip}
              disableHoverListener
              disableTouchListener
              open={isTooltip}
              placement="left"
            >
              <IconButton onClick={handleOpenTooltip}>
                <Help />
              </IconButton>
            </Tooltip>
          </InputAdornment>
        ),
      }}
    ></TextField>
  );
}
